<template>
  <div id="mmpCategoryMenu" class="wrap_mmp_category" >
    <div class="inner">
      <div
        v-if="!isDesktop"
        class="wrap_category_search"
      >
        <!-- 검색 레이어 열기 버튼 -->
        <button
          class="btn_open_search"
          @click="searchMenuOpen()"
        >원하는 강의를 검색하세요</button>
        <!-- // 검색 레이어 열기 버튼 -->

        <!-- 카테고리 닫기 버튼 -->
        <button
          ref="btnCategoryCloseMo"
          class="btn_close_category_mo"
          @click="categoryMenuClose()"
        >카테고리 닫기</button>
        <!-- // 카테고리 닫기 버튼 -->
      </div>
      <div class="wrap_category_header">
        <span class="category_tit">카테고리</span>
        <!-- IT 로드맵 -->
        <RoadMapButton/>
        <!-- // IT 로드맵 -->
      </div>
      <div class="wrap_category_menu">
        <div class="inner">
          <!-- 1 depth item -->
          <ul
            :class="['list', 'depth_1', {'custom_scroll' : isDesktop}]"
          >
            <li
              v-for="(item, index) in categoryMenuList" :key="index"
            >
              <button
                :data-category-index="index"
                :data-url="item.link"
                :class="['link_category_item', {'has_sub_item' : item.subItem && item.subItem.length > 0}]"
                data-category-depth="1"
                @pointerover="categoryMenuOver"
                @click="goToCategory(item, $event)"
              >{{ item.name }}</button>
            </li>
          </ul>
          <!-- // 1 depth item -->

          <!-- 2 depth item -->
          <ul
            :class="['list', 'depth_2', 'hide', {'custom_scroll' : isDesktop}]"
          >
            <li v-if="!isDesktop">
              <button
                :data-category-index="0"
                class="link_category_item"
                @click="goToCategoryAll()"
              >전체</button>
            </li>
            <li
              v-for="(item, index) in category2DepthList"
              :key="index"
            >
              <button
                :data-category-index="index"
                :data-url="item.link"
                :class="['link_category_item', {'has_sub_item' : item.subItem && item.subItem.length > 0}]"
                data-category-depth="2"
                @pointerover="categoryMenuOver"
                @click="goToCategory(item, $event)"
              >{{ item.name }}</button>
            </li>
          </ul>
          <!-- // 2 depth item -->

          <!-- 3 depth item -->
          <ul
            v-show="isDesktop"
            :class="['list', 'depth_3', 'hide', {'custom_scroll' : isDesktop}]"
          >
            <li
              v-for="(item, index) in category3DepthList"
              :key="index"
            >
              <button
                :data-category-index="index"
                :data-url="item.link"
                class="link_category_item"
                data-category-depth="3"
                @pointerover="categoryMenuOver"
                @click="goToCategory(item, $event)"
              >{{ item.name }}</button>
            </li>
          </ul>
          <!-- // 3 depth item -->

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MotionEffects from '@/assets/js/MotionEffects'
import RoadMapButton from '@/components/pages/nrw/common/RoadMapButton.vue'
// import CompMmpSearchMenu from '@/components/pages/nrw/portlet/CompMmpSearchMenu.vue'

export default {
  name: 'CompMmpCategoryMenu',
  components: {
    RoadMapButton
    // CompMmpSearchMenu
  },
  mixins: [
    MotionEffects
  ],
  props: {
    categoryData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      categoryMenuList: [], // 카테고리 메뉴 리스트 (전체)
      category2DepthList: [], // 노출할 2 depth 카테고리 메뉴 리스트
      category3DepthList: [], // 노출할 3 depth 카테고리 메뉴 리스트
      category1DepthIndex: 0, // 1 depth 의 현재 포커스 인덱스
      category2DepthIndex: 0, // 2 depth 의 현재 포커스 인덱스
      category3DepthIndex: 0, // 3 depth 의 현재 포커스 인덱스
      open1DepthIndex: null, // 열려 있는 1뎁스 인덱스
      open2DepthIndex: null, // 열려 있는 2뎁스 인덱스
      isTouchDevice: false // 터치 디바이스 여부
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
      // return !this.isTouch()
    },
    isMobile () {
      return this.isTouchDevice
    }
  },
  watch: {
    categoryData (newVal) {
      if (newVal) {
        this.getCategoryMenu(newVal)
      }
    }
  },
  created () {
    if (this.categoryData) {
      this.getCategoryMenu(this.categoryData)
    }
  },
  mounted () {
    this.detectDevice() // 컴포넌트가 마운트될 때 디바이스 감지
  },
  methods: {
    detectDevice () {
      const ua = navigator.userAgent
      const isMobile = /Mobi|Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|BB10|Opera Mini|IEMobile|Kindle|Silk|PlayBook/i.test(ua)
      this.isTouchDevice = isMobile
    },
    handlePointerEvent (event) {
      this.isTouchDevice = event.pointerType === 'touch' || event.pointerType === 'pen'
    },
    is1DepthOpen (index) {
      return Number(this.open1DepthIndex) === Number(index)
    },
    is2DepthOpen (index) {
      return Number(this.open2DepthIndex) === Number(index)
    },
    // 카테고리 메뉴 초기화 (부모 컴포넌트에서 메뉴 오픈시 호출)
    initCategoryMenu () {
      // this.handlePointerEvent(event)

      const depth1MenuLink = document.querySelectorAll('.wrap_category_menu_expand .depth_1 .link_category_item')
      let i

      // 1 depth 링크 클래스 정리
      for (i = 0; i < depth1MenuLink.length; i++) {
        if (i === 0) {
          depth1MenuLink[i].classList.add('active')
        } else {
          depth1MenuLink[i].classList.remove('active')
        }
      }

      // 2 depth 메뉴 리스트 노출
      this.getSubCategory(0)
    },
    // 메인 카테고리 메뉴 리스트
    getCategoryMenu (categoryData) {
      // console.log('Prop 데이터:', categoryData)
      const result = categoryData.map(depthOne => ({
        // 1 depth item
        name: depthOne.menuNm,
        link: depthOne.linkUrl,
        paramCntnt01: depthOne.paramCntnt01,
        paramCntnt02: depthOne.paramCntnt02,
        paramCntnt03: depthOne.paramCntnt03,
        paramCntnt04: depthOne.paramCntnt04,
        subItem: depthOne.menus.map(depthTwo => ({
          // 2 depth item
          name: depthTwo.menuNm,
          link: depthTwo.linkUrl,
          paramCntnt01: depthTwo.paramCntnt01,
          paramCntnt02: depthTwo.paramCntnt02,
          paramCntnt03: depthTwo.paramCntnt03,
          paramCntnt04: depthTwo.paramCntnt04,
          subItem: depthTwo.menus.map(depthThree => ({
            // 3 depth item
            name: depthThree.menuNm,
            link: depthThree.linkUrl,
            paramCntnt01: depthThree.paramCntnt01,
            paramCntnt02: depthThree.paramCntnt02,
            paramCntnt03: depthThree.paramCntnt03,
            paramCntnt04: depthThree.paramCntnt04
          }))
        }))
      }))

      this.categoryMenuList = result
      if (result.length > 0) this.hasCategoryMenu = true
    },
    /* 2, 3 depth의 서브 카테고리 목록 세팅
      - getSubCategory (0, 1) : 1 depth 첫번째 메뉴의 서브 카테고리 내 2번째 메뉴의 목록 세팅
      - getSubCategory (0) : 1 depth 첫번째 메뉴의 서브 카테고리 목록 세팅
    */
    getSubCategory (depth1Idx, depth2Idx) {
      const menuList = this.categoryMenuList
      const depth2MenuList = document.querySelector('.wrap_category_menu_expand .depth_2')
      const depth3MenuList = document.querySelector('.wrap_category_menu_expand .depth_3')
      const targetDepth = depth2Idx === null || depth2Idx === undefined ? 2 : 3

      if (!menuList[depth1Idx]) {
        return
      }

      const subMenuList = targetDepth === 2 ? menuList[depth1Idx].subItem : menuList[depth1Idx].subItem[depth2Idx].subItem

      if (subMenuList && subMenuList.length > 0) {
        if (targetDepth === 2) {
          depth2MenuList.classList.remove('hide')
          depth3MenuList.classList.add('hide')
          this.category2DepthList = subMenuList
          this.category3DepthList = []
        } else {
          this.category3DepthList = subMenuList
          depth3MenuList.classList.remove('hide')
        }
      } else {
        if (targetDepth === 2) {
          depth2MenuList.classList.add('hide')
          depth3MenuList.classList.add('hide')
          this.category2DepthList = []
          this.category3DepthList = []
        } else {
          depth3MenuList.classList.add('hide')
          this.category3DepthList = []
        }
      }
    },
    // 카테고리 메뉴 마우스 오버 제어 (PC 전용)
    categoryMenuOver (event) {
      // if (!this.isDesktop) return
      this.handlePointerEvent(event)

      const currMenu = (event.target || event.srcElement) // 현재 포커스 링크
      const currIndex = Number(currMenu.getAttribute('data-category-index')) // 현재 포커스 링크의 순서
      const currDepth = Number(currMenu.getAttribute('data-category-depth')) // 현재 포커스 링크의 depth
      const siblingList = document.querySelectorAll('.wrap_category_menu_expand .link_category_item[data-category-depth="' + currDepth + '"]') // 같은 레벨의 메뉴 엘리먼트들
      let item

      // hover 클래스 정리
      for (item of siblingList) {
        if (item === currMenu) {
          item.classList.add('active')
        } else {
          item.classList.remove('active')
        }
      }

      // 현재 포커스 인덱스 저장
      if (currDepth === 1) {
        this.category1DepthIndex = currIndex // 현재 포커스 인덱스 저장
        this.getSubCategory(currIndex)
      } else if (currDepth === 2) {
        // this.open2DepthIndex = currIndex // 2뎁스 인덱스 저장
        this.category2DepthIndex = currIndex // 현재 포커스 인덱스 저장
        this.getSubCategory(this.category1DepthIndex, currIndex)
      } else {
        this.category3DepthIndex = currIndex // 현재 포커스 인덱스 저장
      }
    },
    // 모바일 카테고리 메뉴 닫기
    categoryMenuClose () {
      this.open1DepthIndex = null // 메뉴 닫기
      this.open2DepthIndex = null // 메뉴 닫기
      this.$emit('closeMo')
      // .initSearch(fucusInput) : false 인 경우 입력창 포커스 해제
      // this.$refs.CompMmpSearchMenuMo.initSearch(false) // 검색영역 초기화
    },
    // 카테고리로 이동
    goToCategory (item, event) {
      if (this.isMobile) {
        const currMenu = event.target || event.srcElement // 현재 포커스 링크
        const currIndex = currMenu && Number(currMenu.getAttribute('data-category-index')) // 현재 포커스 링크의 순서
        const currDepth = currMenu && Number(currMenu.getAttribute('data-category-depth')) // 현재 포커스 링크의 depth

        /* if (currDepth === 1) {
          this.categoryMenuOver(event)
        } else {
          this.$emit('beforeCategoryMove')
          this.goMenuLink(item)
          this.categoryMenuClose()
        } */
        if (currDepth === 1) {
          this.handle1DepthClick(currIndex, event)
        } else if (currDepth === 2) {
          this.handle2DepthClick(item, currIndex, event)
        } else {
          this.$emit('beforeCategoryMove')
          this.goMenuLink(item)
          this.categoryMenuClose()
        }
      } else {
        this.$emit('beforeCategoryMove')
        this.goMenuLink(item)
        this.categoryMenuClose()
      }
    },
    goToCategoryAll () { // 2depth 전체 조회
      const item = this.deepClone(this.category2DepthList[0])
      item.name = '전체'
      item.paramCntnt03 = undefined
      item.paramCntnt04 = undefined
      item.subItem = []

      this.$emit('beforeCategoryMove')
      this.goMenuLink(item)
      this.categoryMenuClose()
    },
    // 모바일 통합검색 레이어 팝업 열기
    searchMenuOpen () {
      this.$emit('searchPopOpen')
    },
    handle1DepthClick (index, event) {
      if (this.isTouchDevice) {
        if (this.is1DepthOpen(index)) {
          event.stopPropagation() // 이벤트 버블링 방지
          this.goToCategoryAll() // 1뎁스 전체로 이동
        } else {
          this.open1DepthIndex = index // 2뎁스 열기
        }
      } else {
        event.stopPropagation() // 이벤트 버블링 방지
        this.goToCategoryAll() // 1뎁스 전체로 이동
      }
    },
    handle2DepthClick (item, index, event ) {
      if (this.isTouchDevice) {
        if (!this.isDesktop) {
          event.stopPropagation() // 이벤트 버블링 방지
          this.$emit('beforeCategoryMove')
          this.goMenuLink(item)
          this.categoryMenuClose()
        } else if (this.is2DepthOpen(index)) {
          event.stopPropagation() // 이벤트 버블링 방지
          this.$emit('beforeCategoryMove')
          this.goMenuLink(item)
          this.categoryMenuClose()
        } else if (this.category2DepthList[Number(index)]['subItem'].length === 0) {
          event.stopPropagation() // 이벤트 버블링 방지
          this.$emit('beforeCategoryMove')
          this.goMenuLink(item)
          this.categoryMenuClose()
        } else {
          this.open2DepthIndex = index // 3뎁스 열기
        }
      } else {
        event.stopPropagation() // 이벤트 버블링 방지
        this.$emit('beforeCategoryMove')
        this.goMenuLink(item)
        this.categoryMenuClose()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompMmpCategoryMenu.vue